import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Chart, ChartConfiguration, ChartData } from 'chart.js';
import 'chartjs-adapter-moment';
import { BaseChartDirective } from 'ng2-charts';
import { DailyBalanceStatistic, DailyBalanceStatisticAll } from '../../services/analytics-results.service';

@Component({
  selector: 'app-daily-balance-line-chart',
  templateUrl: './daily-balance-line-chart.component.html',
  styleUrls: ['./daily-balance-line-chart.component.scss']
})
export class DailyBalanceLineChartComponent implements OnChanges {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  @Input()
  public width: string = "400";

  @Input()
  public height: string = "100";

  @Input()
  public dailyBalance: DailyBalanceStatistic[] | DailyBalanceStatisticAll[] = new Array<DailyBalanceStatistic>();

  @Input()
  public showTicks: boolean = true;

  chartPlugins = [];

  chartData: ChartData<'line', number[], Date> = {
    labels: [],
    datasets: [
      {
        fill: true,
        data: []
      }
    ]
  };

  chartOptions: ChartConfiguration['options'] = {
    // We use these empty structures as placeholders for dynamic theming.
    elements: {
      line: {
        tension: 0.25,
      },
      point: {
        hitRadius: 10,
        radius: 0
      }
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: 'month',
          tooltipFormat: 'MMM D'
        },
        display: this.showTicks,
        grid: {
          display: false
        },
        title: {
          display: false,
          text: 'Balance Date'
        }
      },
      y: {
        beginAtZero: false,
        display: true,
        grid: {
          display: false
        },
        position: "right",
        ticks: {
          callback: (value, index, ticks) => {
            let v = value as number;
            if(v) {
              return '$' + v.toLocaleString();
            }
            return '$' + value;
          }
        }
      }
    },
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
        labels: {
          boxWidth: 10
        }
      },
      tooltip: {
        callbacks: {
          label: (item) =>
            `$${item.formattedValue}`
        }
      }
    },
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["dailyBalance"]) {
      if (this.dailyBalance.length > 0) {
        this.buildChartData();
      }
    }

    if (changes["showTicks"]) {
      var c = changes["showTicks"];
      if (c.currentValue !== c.previousValue) {
        this.showHideTicks();
      }
    }
  }

  buildChartData(): void {
    if (this.dailyBalance) {
      let labels = new Array<Date>();
      let data = new Array<number>();


      this.dailyBalance.forEach((x) => {
        labels.push(x.dim_balancedate_date);

        /* see if we can cast the object as an account daily balance stat */
        let account = x as DailyBalanceStatistic;
        if (account.fct_currentbalance !== undefined) {
          data.push(account.fct_currentbalance);
        } else {
          /* see if we can cast the obhect as an all accounts daily balance stat */
          let all = x as DailyBalanceStatisticAll;
          if (all.fct_sum_currentbalance !== undefined) {
            data.push(all.fct_sum_currentbalance);
          }
        }
      });

      this.chartData.labels = labels;
      this.chartData.datasets[0].data = data;

      this.chart?.update();
    }
  }

  showHideTicks() {

    if (this.chartOptions && this.chartOptions.scales && this.chartOptions.scales['x']) {
      this.chartOptions.scales['x'].display = this.showTicks;
    }

    // if(this.chartOptions && this.chartOptions.scales && this.chartOptions.scales['y']) {
    //   this.chartOptions.scales['y'].display = this.showTicks;
    // }

    this.chart?.update();
  }
}
